import { Category } from '../character/allValues';

export enum AttributeExportTypes {
  Resource = 'Resource',
  Attribute = 'Attribute',
  Element = 'Element',
  Dice = 'Dice',
  Talent = 'Talent',
  Weapon = 'Weapon',
}

export interface AttributeExport {
  name: string;
  type: AttributeExportTypes;
  abbreviation: string;
}

export default abstract class BaseAttribute {
  public name: string;
  public abbreviation: string;
  public abstract category: Category;
  public description?: string;

  public constructor(name: string) {
    this.name = name;
    this.abbreviation = this.generateAbbreviation(name);
  }

  public abstract getClone(): BaseAttribute;
  public abstract export(): AttributeExport;

  public abstract toString(): string;

  protected generateAbbreviation(name: string) {
    return name
      .toLowerCase()
      .replace(' ', '_')
      .replace(/\(\)/gi, '')
      .replace('&', 'und')
      .replace('ä', 'ae')
      .replace('ö', 'oe')
      .replace('ü', 'ue');
  }
}
